import React, { useRef, useState } from 'react'
import { generateUniqueId } from '@services/utils.service'
import { useDispatch } from 'react-redux';
import { Button, Input, Loader } from '@nazka/nazka.mapframe.components';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import queryClient from '@utils/queries/QueryClient';

import './buildings-custom-radio.styl'
import { setCurrentBuilding } from '../../../layer-selector.redux.action';

function BuildingsCustomRadio(props) {
  const {
    label, name, value, checked, onChange, selectedValue, isCreatingNewDamageLayer,
  } = props;
  const dispatch = useDispatch()
  const idRef = useRef(generateUniqueId());
  const [isEditOn, setIsEditOn] = useState(false)
  const [newName, setNewName] = useState(null)
  const [placeholderName, setPlaceholderName] = useState(label)

  const { mutate: removeCustomBuilding } = useMutation({
    mutationFn: async (floodId) => {
      await axios.delete(`/api/upload/building/${floodId}`);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['building-records'] })
      dispatch(setCurrentBuilding('default'))
    },
    onSuccess: () => {
      toast.success('Successfully deleted your custom building data')
    },
    onError: error => toast.error(error.message || 'Something went wrong deleting your building extent'),
  });

  const { mutate: updateDamageLayerName, isPending } = useMutation({
    mutationFn: async () => {
      if (newName) {
        await axios.put(`api/upload/building/${value}`, {
          name: newName,
        });
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['building-records'] })
      setNewName(null);
    },
    onSuccess: () => {
      setNewName(null)
      toast.success('Successfully updated your building data')
    },
    onError: () => toast.error('Something went wrong updating your building data'),
  });

  const editHandler = (e, mode) => {
    e.preventDefault()
    if (mode === 'edit') {
      setIsEditOn(prevState => !prevState)
    }
    
    if (newName) {
      updateDamageLayerName()
    }
  }

  return (
    <form className="builds-custom-radio" onSubmit={editHandler}>
      <div>
        <input
          id={idRef.current}
          className="radio__input"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        {isPending ? (
          <Loader
            css={{
              height: '40px',
              width: '40px',
            }}
          />
        ) : (
          <label htmlFor={idRef.current} className="radio__label">
            {isEditOn ? (
              <Input 
                onInputChange={(e) => {
                  setNewName(e.target.value)
                  setPlaceholderName(e.target.value)
                }} 
                rootElProps={{ placeholder: 'New damage layer name' }}
                css={{
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  outline: 'none',
                  height: '25px',
                }}
                value={placeholderName}
              />
            ) : (
              <span contentEditable={isEditOn}>
                {label.length > 25
                  ? `${label.substring(0, 20)}...`
                  : label}
              </span>
            )}
          
          </label>
        )}
      </div>
      {value !== 'default' && !isCreatingNewDamageLayer && (
      <div className="builds-custom-radio__btn-wrapper">
        <Button 
          icon={faPencil} 
          onClick={e => editHandler(e, 'edit')}
          color="white"
          hover={false}
          className="layer-selector__delete__button"
          iconProps={{
            size: '14px',
          }}
          css={{
            color: 'grey',
            marginLeft: 0,
            padding: 0,
            '&:hover': {
              color: 'black',
            },
            '&:disabled': {
              backgroundColor: 'transparent',
              border: 'none',
              color: 'grey',
              '&:hover': {
                color: 'grey',
              },
            },
          }}
        />
        <Button
          icon={faTrash} 
          onClick={() => removeCustomBuilding(value)} 
          color="white"
          hover={false}
          className="layer-selector__delete__button"
          iconProps={{
            size: '14px',
          }}
          css={{
            color: 'grey',
            marginLeft: 0,
            padding: 0,
            '&:hover': {
              color: 'black',
            },
            '&:disabled': {
              backgroundColor: 'transparent',
              border: 'none',
              color: 'grey',
              '&:hover': {
                color: 'grey',
              },
            },
          }}
        />
      </div>
      )}
      
    </form>
  )
}

export default BuildingsCustomRadio